import { ComparisonPageTemplate } from "@/components/ComparisonPageTemplate";
import { Brain, Users, Clock } from "lucide-react";

const CSWvsRemNote = () => {
  return (
    <ComparisonPageTemplate
      platformName="RemNote"
      platformUrl="https://www.remnote.com"
      seoDescription="Compare CSW and RemNote study platforms. Discover why CSW offers better performance and collaborative features."
      seoKeywords="CSW vs RemNote, RemNote alternative, free flashcard app, note-taking flashcards"
      canonicalUrl="https://csw.live/flash-cards/csw-vs-remnote/"
      heroDescription="Looking for a simpler alternative to RemNote? CSW offers collaborative study and gamified learning without performance issues."
      alternativeDescription="While RemNote combines notes with flashcards, CSW provides a focused, collaborative study environment that's fast."
      background="RemNote combines note-taking with hierarchical organization, bi-directional links, and spaced-repetition flashcards."
      pros={[
        { text: "Combines notes and flashcards" },
        { text: "Knowledge graph visualization" },
        { text: "Spaced-repetition integration" }
      ]}
      cons={[
        { text: "Large knowledge bases slow performance" },
        { text: "Pricing may feel restrictive" },
        { text: "Steep learning curve" }
      ]}
      cswFeatures={[
        { text: "Fast Performance", available: true },
        { text: "Collaborative Study", available: true },
        { text: "Gamified Learning", available: true },
        { text: "Easy to Use", available: true }
      ]}
      competitorFeatures={[
        { text: "Fast Performance", available: false },
        { text: "Collaborative Study", available: false },
        { text: "Gamified Learning", available: false },
        { text: "Easy to Use", available: false }
      ]}
      benefits={[
        { icon: Brain, title: "Lightning Fast", description: "No slowdowns, study smoothly with any content." },
        { icon: Users, title: "Social Study", description: "Collaborate with classmates in real-time." },
        { icon: Clock, title: "Simple & Focused", description: "Get straight to studying without complexity." }
      ]}
      forStudentsText="CSW offers what RemNote complicates—fast, focused flashcard study with collaboration."
      pricingText="RemNote's pricing can be restrictive. CSW provides unlimited access free."
      competitorPrice="$8/month"
    />
  );
};

export default CSWvsRemNote;
